import React from "react";

function RequestDetails({
  requestDetails,
  clickReset,
  handleApprove,
  handleReject,
}) {
  console.log("requestDetails", requestDetails);
  return (
    <div className="card p-3 shadow-sm w-100 mt-3" style={{ fontSize: "12px" }}>
      <h6 className="fw-bold" style={{ color: "#d38740" }}>
        Request Details
      </h6>
      <p className="mb-1">
        <strong>Coordinator Name:</strong>{" "}
        {requestDetails?.coordinator?.employee?.firstName}{" "}
        {requestDetails?.coordinator?.employee?.middleName}{" "}
        {requestDetails?.coordinator?.employee?.lastName}
      </p>
      <p className="mb-1">
        <strong>Employee Name:</strong> {requestDetails?.employee?.firstName}{" "}
        {requestDetails?.employee?.middleName}{" "}
        {requestDetails?.employee?.lastName}
      </p>
      <p className="mb-1">
        <strong>Type of Request:</strong> {requestDetails?.requestType}
      </p>
      <p className="mb-1">
        <strong>Remarks:</strong> {requestDetails?.remarks}
      </p>

      <p className="mb-1 mt-4">
        <strong>File Attached:</strong>
        {requestDetails?.attachmentArray?.map((file, index) => {
          // Extract only the actual filename (removing the unique identifier)
          const fileName = file.split("/").pop().split("_").slice(1).join("_");

          return (
            <div
              key={index}
              className="d-flex align-items-center p-2 mt-2"
              style={{
                backgroundColor: "#fbfbfb",
                borderRadius: "5px",
                border: "1px solid #ddd",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                maxWidth: "400px",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  src="https://cdn-icons-png.flaticon.com/512/337/337946.png" // Replace with your own PDF icon
                  alt="PDF Icon"
                  style={{ width: "20px", height: "20px", marginRight: "10px" }}
                />
                <span style={{ fontSize: "14px", wordBreak: "break-word" }}>
                  {fileName}
                </span>
              </div>
              <a
                href={file}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  fontSize: "14px",
                  color: "#007bff",
                  textDecoration: "none",
                }}
              >
                View
              </a>
            </div>
          );
        })}
      </p>

      {/* Buttons */}

      <div className="d-flex justify-content-between mt-3">
        <button
          className="flex-grow-1 btn text-white me-2"
          style={{ backgroundColor: "#d18237" }}
          onClick={handleApprove}
        >
          <i class="bi bi-check-lg"></i>
          Approve
        </button>
        <button
          className="flex-grow-1 btn text-dark"
          style={{ backgroundColor: "#e5e5e5" }}
          onClick={handleReject}
        >
          <i class="bi bi-x"></i>
          Reject
        </button>
      </div>
    </div>
  );
}

export default RequestDetails;
